import React, { Component } from "react";
import { message } from "antd";
import {isEmpty, map} from 'lodash';
import * as yup from "yup";

const serviceData = [
  {
    name: 'Pet Waste Station Service',
    value: 'pet_waste_station_service'
  },
  {
    name: 'Common Area Cleaning',
    value: 'common_area_cleaning'
  },
  {
    name: 'Trash Can Service',
    value: 'trash_can_service'
  },
];
const productData = [
  {
    name: 'Pet Waste Stations',
    value: 'pet_waste_stations'
  },
  {
    name: 'Pet Waste Station Bags',
    value: 'pet_waste_station_bags'
  }
];
const bagsData = [
  {
    name: 'Header Bags',
    value: 'header_bags'
  },
  {
    name: 'Roll Bags',
    value: 'roll_bags'
  },
  {
    name: 'I Don’t Know',
    value: 'dont_know'
  },
];
const stationInstallingData = [
  {
    name: '1-5',
    value: '1-5'
  },
  {
    name: '6-10',
    value: '6-10'
  },
  {
    name: '11-20+',
    value: '11-20+'
  },
  {
    name: 'I Don’t Know',
    value: 'dont_know'
  }
];
const serviceFrequencyData = [
  {
    name: 'Twice Weekly',
    value: 'twice_weekly'
  },
  {
    name: 'Weekly',
    value: 'weekly'
  },
  {
    name: 'Every Other Week',
    value: 'bi_monthly'
  },
  {
    name: 'Other',
    value: 'other'
  }
];
const cleaningAreasData = [
  {
    name: 'All Common Areas',
    value: 'all_common_areas'
  },
  {
    name: 'Specific Locations',
    value: 'specific_locations'
  }
];

class ServiceInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      service: [],
      product: [],
      petWaste: {
        stationInstalled: false,
        stationInstalling: '',
        stationCount: '',
        stationMap: {},
        bags: []
      },
      trashCan: {
        stationInstalled: false,
        stationInstalling: '',
        stationCount: '',
        stationMap: {},
      },
      cleanArea: {
        area: [],
        stationMap: {}
      },
      serviceFrequency: '',
      comment: '',
      commercialData: {},
      is_pet_img: false,
      is_trash_img: false,
      is_clean_img: false,
      isLocalValueChanged: true,
      errors: {}
    }
    this.pet_upload = null
    this.trash_upload = null
    this.clean_upload = null
  }

  componentDidMount = () => {
    this.storeInLocal()
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { commercialData } = nextProps
    if (!isEmpty(commercialData) && this.state.isLocalValueChanged) {
      let url = commercialData?.pet_waste_station_map?.split('?') || [];
      let pet_waste_file_name = url?.[0]?.split('/')?.[url?.[0]?.split('/')?.length - 1]
      let pet_waste_type = pet_waste_file_name?.includes('.pdf') ? 'application/pdf' : '';
      let pet_waste_blob = new Blob(url)

      url = commercialData?.trash_can_location_map?.split('?') || [];
      let trash_can_file_name = url?.[0]?.split('/')?.[url?.[0]?.split('/')?.length - 1]
      let trash_can_type = trash_can_file_name?.includes('.pdf') ? 'application/pdf' : '';
      let trash_can_blob = new Blob(url)

      url = commercialData?.common_area_cleaning_map?.split('?') || [];
      let clean_area_file_name = url?.[0]?.split('/')?.[url?.[0]?.split('/')?.length - 1]
      let clean_area_type = clean_area_file_name?.includes('.pdf') ? 'application/pdf' : '';
      let clean_area_blob = new Blob(url)


      let obj = {
        service: commercialData?.interested_services || [],
        product: commercialData?.interested_products || [],
        petWaste: {
          stationInstalled: commercialData?.is_pet_waste_stations_installed || false,
          stationInstalling: commercialData?.new_pet_waste_stations_interested || '',
          stationCount: commercialData?.existing_pet_waste_stations_count || '',
          stationMap: commercialData?.pet_waste_station_map ? { name: pet_waste_file_name, uri: commercialData?.pet_waste_station_map, type: pet_waste_type, size: pet_waste_blob?.size } : {},
          bags: commercialData?.bag_type || [],
        },
        trashCan: {
          stationInstalled: commercialData?.is_trash_cans_installed || false,
          stationInstalling: commercialData?.new_trash_cans_interested || '',
          stationCount: commercialData?.trash_cans_count || '',
          stationMap: commercialData?.trash_can_location_map ? { name: trash_can_file_name, uri: commercialData?.trash_can_location_map, type: trash_can_type, size: trash_can_blob?.size } : {},
        },
        cleanArea: {
          area: commercialData?.areas_to_clean || [],
          stationMap: commercialData?.common_area_cleaning_map ? { name: clean_area_file_name, uri: commercialData?.common_area_cleaning_map, type: clean_area_type, size: clean_area_blob?.size } : {}
        },
        serviceFrequency: commercialData?.current_frequency || '',
        comment: commercialData?.additional_comments || '',
      }
      this.setState({...obj, commercialData, isLocalValueChanged: false})
    }
  }

  // on service detail change
  onTextChange = (e, type) => {
    const value = type === 'bool' ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value }, () => this.storeInLocal())
  }

  // service and product detail change
  onArrayChanged = (value, type) => {
    const { service = [], product = [] } = this.state;
    let data = type === 'service' ? service : product;
    const idx = data?.indexOf(value);
    if (idx > -1 && type === 'product') {
      if (data[idx] === 'pet_waste_station_service') this.setState({petWaste: {
        stationInstalled: false,
        stationInstalling: '',
        stationCount: '',
        stationMap: {},
        bags: []
      } }, () => this.storeInLocal())
      if (data[idx] === 'common_area_cleaning') this.setState({trashCan: {
        stationInstalled: false,
        stationInstalling: '',
        stationCount: '',
        stationMap: {},
      } }, () => this.storeInLocal())
      if (data[idx] === 'trash_can_service') this.setState({cleanArea: {
        area: [],
        stationMap: {}
      } }, () => this.storeInLocal())
    }
    idx > -1 ? data.splice(idx, 1) : data.push(value);
    this.setState({ [type]: data }, () => this.storeInLocal())
  };

  // validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    console.log(((!isNaN(value) && reg.test(value)) || value === '' || value === '-'))
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  };

  // get base 64 string
  getBase64String = (file = {}, cb) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = function () {
      cb(reader.result);
    }
  };

  // on pet waste detail change
  onPetWasteChanged = (e, type) => {
    const { petWaste } = this.state;
    const value = type === 'bool' ? e.target.checked : e.target.value;

    if (e.target.name === 'bags') {
      if (e.target.value.length > 0) {
        const idx = petWaste?.bags?.indexOf(value);
        idx === -1 ? petWaste.bags.push(value) : petWaste.bags.splice(idx, 1)
      } else {
        petWaste.bags = []
      }
    } else if (e.target.name === 'image') {
      // message.destroy();
      // station map
      let file = e?.target?.files?.[0];
      if (file?.type === 'application/pdf') {
        if (file?.size > (5 * 1048576)) {
          message.error('Image size should be less than 5MB');
        } else {
          file && this.getBase64String(file, (result) => {
            Object.assign(petWaste, { 'stationMap': { name: file.name, size: file.size, uri: result, type: file.type } })
            this.setState({ petWaste, is_pet_img: true }, () => this.storeInLocal())
          });
        }
      } else {
        message.error('Uploaded file is not a valid');
      }
    } else {
      Object.assign(petWaste, { [e.target.name]: value })
    }
    this.setState({ petWaste }, () => this.storeInLocal())
  }

  // on pet waste detail change
  onTrashCanChanged = (e, type) => {
    const { trashCan } = this.state;
    const value = type === 'bool' ? e.target.checked : e.target.value;

    if (e.target.name === 'image') {
      // message.destroy();
      // station map
      let file = e?.target?.files?.[0];
      if (file?.type === 'application/pdf') {
        if (file?.size > (5 * 1048576)) {
          message.error('Image size should be less than 5MB');
        } else {
          file && this.getBase64String(file, (result) => {
            Object.assign(trashCan, { 'stationMap': { name: file.name, size: file.size, uri: result, type: file.type } })
            this.setState({ trashCan, is_trash_img: true }, () => this.storeInLocal())
          });
        }
      } else {
        message.error('Uploaded file is not a valid');
      }
    } else {
      Object.assign(trashCan, { [e.target.name]: value })
      this.setState({ trashCan }, () => this.storeInLocal())
    }
  }

  // on pet waste detail change
  onCleanAreaChanged = (e) => {
    const { cleanArea } = this.state;

    if (e.target.name === 'image') {
      // station map
      // message.destroy();
      let file = e?.target?.files?.[0];
      if (file.type === 'application/pdf') {
        if (file?.size > (5 * 1048576)) {
          message.error('Image size should be less than 5MB');
        } else {
          file && this.getBase64String(file, (result) => {
            Object.assign(cleanArea, { 'stationMap': { name: file.name, size: file.size, uri: result, type: file.type } })
            this.setState({ cleanArea, is_clean_img: true }, () => this.storeInLocal())
          });
        }
      } else {
        message.error('Uploaded file is not a valid');
      }
    } else {
      const idx = cleanArea.area.indexOf(e.target.value);
      idx === -1 ? cleanArea.area.push(e.target.value) : cleanArea.area.splice(idx, 1)
      this.setState({ cleanArea }, () => this.storeInLocal())
    }
  }

  // store data in local
  storeInLocal = () => {
    const {
      product,
      service,
      petWaste,
      trashCan,
      cleanArea,
      serviceFrequency,
      comment,
      is_pet_img,
      is_trash_img,
      is_clean_img,
    } = this.state;

    this.setState({isLocalValueChanged: true})
    const isPetWasteStation = service?.includes("pet_waste_station_service");
    const isCommonCleaningArea = service?.includes("common_area_cleaning");
    const isTrashCan = service?.includes("trash_can_service");

    let obj = {
      interested_products: product,
      interested_services: service,
      is_pet_waste_stations_installed: isPetWasteStation ? petWaste?.stationInstalled : false,
      existing_pet_waste_stations_count: isPetWasteStation ? petWaste?.stationCount : '',
      pet_waste_station_map: isPetWasteStation ? petWaste?.stationMap?.uri || '' : '',
      pet_waste_station_map_name: isPetWasteStation ? petWaste?.stationMap?.name || '' : '',
      new_pet_waste_stations_interested: isPetWasteStation ? petWaste?.stationInstalling : '',
      bag_type: isPetWasteStation ? petWaste?.bags : [],
      areas_to_clean: isCommonCleaningArea ? cleanArea?.area : [],
      common_area_cleaning_map: isCommonCleaningArea ? cleanArea?.stationMap?.uri || '' : '',
      common_area_cleaning_map_name: isCommonCleaningArea ? cleanArea?.stationMap?.name || '' : '',
      is_trash_cans_installed: isTrashCan ? trashCan?.stationInstalled : false,
      trash_cans_count: isTrashCan ? trashCan?.stationCount : '',
      trash_can_location_map: isTrashCan ? trashCan?.stationMap?.uri || '' : '',
      trash_can_location_map_name: isTrashCan ? trashCan?.stationMap?.name || '' : '',
      new_trash_cans_interested: isTrashCan ? trashCan?.stationInstalling : '',
      current_frequency: serviceFrequency,
      additional_comments: comment,
      is_pet_img,
      is_trash_img,
      is_clean_img
    }
    this.props.setCommercialData(obj);

    sessionStorage.setItem('service_info', JSON.stringify({product,
      service,
      petWaste,
      trashCan,
      cleanArea,
      serviceFrequency,
      comment,
      is_pet_img,
      is_trash_img,
      is_clean_img
    }))
  }

  // validate required field
  validate = () => {
    const service_info_data = JSON.parse(sessionStorage.getItem('service_info'))

    const {petWaste, trashCan, cleanArea} =  service_info_data;

    const FILE_SIZE = 5 * 1048576;
    const SUPPORTED_FORMATS = ["application/pdf"];

    const schema = yup.object().shape({
      petWaste: yup.object().shape({
        stationMap: yup.mixed().test("fileSize", "File too large", obj => {
          if (!isEmpty(obj)) return (obj.size <= FILE_SIZE)
          return true
        }).test("fileFormat", "Unsupported Format", obj => {
          if (!isEmpty(obj)) return (SUPPORTED_FORMATS.includes(obj.type))
          return true
        }),
      }),
      trashCan: yup.object().shape({
        stationMap: yup.mixed().test("fileSize", "File too large", obj => {
          if (!isEmpty(obj)) return (obj.size <= FILE_SIZE)
          return true
        }).test("fileFormat", "Unsupported Format", obj => {
          if (!isEmpty(obj)) return (SUPPORTED_FORMATS.includes(obj.type))
          return true
        }),
      }),
      cleanArea: yup.object().shape({
        stationMap: yup.mixed().test("fileSize", "File too large", obj => {
          if (!isEmpty(obj)) return (obj.size <= FILE_SIZE)
          return true
        }).test("fileFormat", "Unsupported Format", obj => {
          if (!isEmpty(obj)) return (SUPPORTED_FORMATS.includes(obj.type))
          return true
        }),
      }),
    });

    const data = {
      petWaste,
      trashCan,
      cleanArea,
    };

    return schema.validate(data, { abortEarly: false }).then(() => {
      return Promise.resolve('success')
    }).catch((error) => {
      let err_data = {};
      map(error?.inner, (item) => {err_data[item.path] = item.message})
      this.setState({errors: err_data, is_btn_active: false})
      return Promise.reject('fail')
    })
  };

  //render service
  renderService = (item, index) => {
    const { service } = this.state;
    const isSelected = service?.includes(item.value);

    return (
      <div className="inline-checks" key={`service${index}`}>
        <label htmlFor={item?.value} className={isSelected ? 'active' : ''}>
          <input type="checkbox" id={item?.value} name="service" className="" value={item?.value} onChange={() => this.onArrayChanged(item?.value, 'service')} />
          <span>{item?.name}</span>
        </label>
      </div>
    )
  };

  //render product
  renderProduct = (item, index) => {
    const { product } = this.state;
    const isSelected = product?.includes(item.value);

    return (
      <div className="inline-checks" key={`product${index}`}>
        <label htmlFor={item?.value} className={isSelected ? 'active' : ''}>
          <input type="checkbox" id={item?.value} name="product" className="" value={item?.value} onChange={() => this.onArrayChanged(item?.value, 'product')} />
          <span>{item?.name}</span>
        </label>
      </div>
    )
  };

  // render trash can
  renderTrashCan = () => {
    const { trashCan, errors } = this.state;
    return (
      <div>
        <h3>Trash Can Station</h3>
        <p>Tell us more about what service are you looking for.</p>
        <div className="flex">
          <h4 className={"flex-1"}>Does community have trash can stations installed?</h4>
          <div className="chk_switch flex-1">
            <div className="can-toggle can-toggle--size-small">
              <input className="fitem-ck-input" id="trash_can" type="checkbox" name={"stationInstalled"} checked={!trashCan?.stationInstalled} onChange={(e) => {
                this.onTrashCanChanged({ target: { name: 'stationCount', value: '' }})
                this.onTrashCanChanged({ target: { name: 'stationMap', value: {} }})
                this.onTrashCanChanged({ target: { name: 'bags', value: [] }})
                this.onTrashCanChanged({ target: { name: 'stationInstalling', value: '' }})
                this.onTrashCanChanged({ target: { name: 'stationInstalled', value: !e.target.checked } })
              }} />
              <label htmlFor="trash_can" className="fitem-ck-txt black">
                <div className="can-toggle__switch"
                  data-unchecked="Yes"
                  data-checked="No"
                />
              </label>
            </div>
          </div>
        </div>
        {
          trashCan?.stationInstalled ?
            <div>
              <div className="frow">
                <div className="fitem">
                  <input
                    name="stationCount"
                    type="text"
                    placeholder={'How many trash cans?'}
                    value={trashCan?.stationCount}
                    onChange={(e) => this.onNumericInputChange(e.target.value) && this.onTrashCanChanged(e)}
                  />
                </div>
              </div>
              <div className="frow">
                <div className="fitem">
                  <input
                    name={"image"}
                    type="file"
                    accept="application/pdf"
                    ref={(ref) => this.trash_upload = ref}
                    style={{ "display": "none" }}
                    onChange={(e) => this.onTrashCanChanged(e)}
                  />
                  <input
                    name="trash_can_map"
                    type="text"
                    placeholder={'Upload trash can location map (optional)'}
                    value={trashCan?.stationMap?.name || ''}
                    readOnly={true}
                    onClick={() => this.trash_upload.click()}
                  />
                  {errors?.['trashCan.stationMap'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['trashCan.stationMap']}</label> : ''}
                </div>
              </div>

            </div> :
            <div className="frow">
              <h4>How many trash cans are you interested in installing/servicing?</h4>
              <div className="oplist">
                {stationInstallingData?.map((item, index) => {
                  const { trashCan } = this.state;
                  const isSelected = trashCan?.stationInstalling === item.value;

                  return (
                    <div className="inline-checks" key={`trashStationInstalled${index}`}>
                      <label htmlFor={item?.value} className={isSelected ? 'active' : ''}>
                        <input type="checkbox" id={item?.value} name="stationInstalling" className="" value={item?.value} onChange={() => this.onTrashCanChanged({ target: { name: 'stationInstalling', value: item?.value } })} />
                        <span>{item?.name}</span>
                      </label>
                    </div>
                  )
                })}
              </div>
            </div>
        }
      </div>
    )
  }

  // render common area cleaning
  renderAreaCleaning = () => {
    const { cleanArea, errors } = this.state;
    return (
      <div>
        <h3>Common Area Cleaning</h3>
        <p>Tell us more about what service are you looking for.</p>
        <div className="frow">
          <h4>What areas would you like to have cleaned? <small>(select multiple)</small></h4>
          <div className="oplist">
            {cleaningAreasData?.map((item, index) => {
              const { cleanArea } = this.state;
              const isSelected = cleanArea?.area?.includes(item.value);

              return (
                <div className="inline-checks" key={`cleanArea${index}`}>
                  <label htmlFor={item?.value} className={isSelected ? 'active' : ''}>
                    <input type="checkbox" id={item?.value} name="area" className="" value={item?.value} onChange={() => this.onCleanAreaChanged({ target: { name: 'area', value: item?.value } })} />
                    <span>{item?.name}</span>
                  </label>
                </div>
              )
            })}
          </div>
        </div>
        <div className="frow">
          <div className="fitem">
            <input
              name={"image"}
              type="file"
              accept="application/pdf"
              ref={(ref) => this.clean_upload = ref}
              style={{ "display": "none" }}
              onChange={(e) => this.onCleanAreaChanged(e)}
            />
            <input
              name="clean_area_map"
              type="text"
              placeholder={'Upload common area location map (optional)'}
              value={cleanArea?.stationMap?.name || ''}
              readOnly={true}
              onClick={() => this.clean_upload.click()}
            />
            {errors?.['cleanArea.stationMap'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['cleanArea.stationMap']}</label> : ''}
          </div>
        </div>
      </div>
    )
  }

  // render pet waste
  renderPetWaste = () => {
    const { petWaste, errors } = this.state;
    return (
      <div>
        <h3>Pet Waste Station</h3>
        <p>Tell us more about what service are you looking for.</p>
        <div className="flex">
          <h4 className={"flex-1"}>Does community have pet waste stations installed?</h4>
          <div className="chk_switch flex-1">
            <div className="can-toggle can-toggle--size-small">
              <input className="fitem-ck-input" id="pet_waste" type="checkbox" name={"stationInstalled"} checked={!petWaste?.stationInstalled} onChange={(e) => {
                this.onPetWasteChanged({ target: { name: 'stationCount', value: '' }})
                this.onPetWasteChanged({ target: { name: 'stationMap', value: {} }})
                this.onPetWasteChanged({ target: { name: 'bags', value: [] }})
                this.onPetWasteChanged({ target: { name: 'stationInstalling', value: '' }})
                this.onPetWasteChanged({ target: { name: 'stationInstalled', value: !e.target.checked }})
              }} />
              <label htmlFor="pet_waste" className="fitem-ck-txt black">
                <div className="can-toggle__switch"
                  data-unchecked="Yes"
                  data-checked="No"
                />
              </label>
            </div>
          </div>
        </div>
        {
          petWaste?.stationInstalled ?
            <div>
              <div className="frow">
                <div className="fitem">
                  <input
                    name="stationCount"
                    type="text"
                    placeholder={'How many pet waste station do you have?'}
                    value={petWaste?.stationCount}
                    onChange={(e) => this.onNumericInputChange(e.target.value) && this.onPetWasteChanged(e)}
                  />
                </div>
              </div>
              <div className="frow">
                <div className="fitem">
                  <input
                    name={"image"}
                    type="file"
                    accept="application/pdf"
                    ref={(ref) => this.pet_upload = ref}
                    style={{ "display": "none" }}
                    onChange={(e) => this.onPetWasteChanged(e)}
                  />
                  <input
                    name="stationMap"
                    type="text"
                    placeholder={'Upload pet waste location map (optional)'}
                    value={petWaste?.stationMap?.name || ''}
                    readOnly={true}
                    onClick={() => this.pet_upload.click()}
                  />
                </div>
                {errors?.['petWaste.stationMap'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['petWaste.stationMap']}</label> : ''}
              </div>
              <div className="frow">
                <h4>What type of bags do you use? <small>(select all that apply)</small></h4>
                <div className="oplist">
                  {bagsData?.map((item, index) => {
                    const { petWaste } = this.state;
                    const isSelected = petWaste?.bags?.includes(item.value);

                    return (
                      <div className="inline-checks" key={`petBag${index}`}>
                        <label htmlFor={item?.value} className={isSelected ? 'active' : ''}>
                          <input type="checkbox" id={item?.value} name="bags" className="" value={item?.value} onChange={() => this.onPetWasteChanged({ target: { name: 'bags', value: item?.value } })} />
                          <span>{item?.name}</span>
                        </label>
                      </div>
                    )
                  })}
                </div>
              </div>

            </div> :
            <div className="frow">
              <h4>How many pet waste stations are you interested in installing/servicing?</h4>
              <div className="oplist">
                {stationInstallingData?.map((item, index) => {
                  const { petWaste } = this.state;
                  const isSelected = petWaste?.stationInstalling === item.value;

                  return (
                    <div className="inline-checks" key={`petStationInstalled${index}`}>
                      <label htmlFor={item?.value} className={isSelected ? 'active' : ''}>
                        <input type="checkbox" id={item?.value} name="stationInstalling" className="" value={item?.value} onChange={() => this.onPetWasteChanged({ target: { name: 'stationInstalling', value: item?.value } })} />
                        <span>{item?.name}</span>
                      </label>
                    </div>
                  )
                })}
              </div>
            </div>
        }
      </div>
    )
  }

  render() {
    const { service, serviceFrequency, petWaste, trashCan, comment } = this.state;
    return (
      <div>
        <h3>Service Information</h3>
        <div className="form-group">
          <div className="frow">
            <h4>What service are you interested in?</h4>
            <div className="oplist">
              {serviceData?.map(this.renderService)}
            </div>
          </div>
          <div className="frow">
            <h4>What products are you interested in?</h4>
            <div className="oplist">
              {productData?.map(this.renderProduct)}
            </div>
          </div>
        </div>

        <hr />
        {service?.includes('pet_waste_station_service') && this.renderPetWaste()}
        {service?.includes('common_area_cleaning') && this.renderAreaCleaning()}
        {service?.includes('trash_can_service') && this.renderTrashCan()}

        {(service?.includes('pet_waste_station_service') && petWaste?.stationInstalled) || (service?.includes('trash_can_service') && trashCan?.stationInstalled) ?
          <div className="frow">
            <h4>What is your current frequency of your service? <small>(select one)</small></h4>
            <div className="oplist">
              {serviceFrequencyData?.map((item, index) => {
                const isSelected = serviceFrequency === item.value;

                return (
                  <div className="inline-checks" key={`frequency${index}`}>
                    <label htmlFor={item?.value} className={isSelected ? 'active' : ''}>
                      <input type="checkbox" id={item?.value} name="serviceFrequency" className="" value={item?.value} onChange={() => this.onTextChange({ target: { name: 'serviceFrequency', value: item?.value } })} />
                      <span>{item?.name}</span>
                    </label>
                  </div>
                )
              })}
            </div>
          </div> : ''
        }

        <div className="fitem">
          <h4>Are there any other additional comments or concerns you would like to share with us?</h4>
          <textarea
            id={"comment"}
            rows="4"
            name="comment"
            type="text"
            placeholder={"Let us know!"}
            value={comment}
            onChange={(e) => this.onTextChange(e)} />
        </div>
      </div>
    );
  }
}

export default ServiceInfo;